import { render, staticRenderFns } from "./SharePromptList.vue?vue&type=template&id=1cdc8e0e&"
import script from "./SharePromptList.vue?vue&type=script&lang=js&"
export * from "./SharePromptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports